import React from "react";
import TextField from "@mui/material/TextField";

function CustomNoteAggiungi2({
  name,
  label,
  type,
  onChange,
  value,
  maxLength,
  disabled,
}) {
  const handleChange = (e) => {
    const { value } = e.target;
    onChange(value); // Passa il valore direttamente
  };

  return (
    <TextField
      name={name}
      label={label}
      type={type}
      variant="outlined"
      fullWidth
      disabled={disabled}
      inputProps={{
        maxLength: maxLength,
      }}
      multiline
      rows={4}
      value={value || ""} // Usa direttamente il valore
      onChange={onChange}
      sx={{
        width: "100%",
        textAlign: "left",
        borderRadius: "10px",
        backgroundColor: "#FFFFFF",
        "& .MuiOutlinedInput-root": {
          "& fieldset": {
            borderColor: "#fda03d",
          },
          "&:hover fieldset": {
            borderColor: "#fda03d",
          },
          "&.Mui-focused fieldset": {
            borderColor: "#fda03d",
          },
        },
        "& .MuiOutlinedInput-root.Mui-disabled": {
          bgcolor: "transparent",
          cursor: "not-allowed",
        },
        "& .Mui-disabled": {
          cursor: "not-allowed",
        },
        "& .MuiInputLabel-root.Mui-focused": {
          color: "#fda03d",
        },
      }}
    />
  );
}

export default CustomNoteAggiungi2;
